import { css } from "styled-components";
export default css`
    .ant-input {
        &:hover, &:focus, &-affix-wrapper:hover, &-affix-wrapper-focused {
            border-color: #AAD370;
        }
        &:focus, &-affix-wrapper-focused {
            box-shadow: 0 0 0 2px #AAD37055;    
        }
    }
`;